
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';

import { UserSession } from '@src/lib';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { matureArtworksPath } from '@src/constants/Artworks';
import { useRouter } from 'next/router';
import SeoComponent from '@src/view/common/seo/SeoCompnent';

const ArtworksComponent = dynamic<any>(
  () =>
    import('@src/view/components/artworks').then(
      (mod: any) => mod.ArtworksComponent,
    ),
  {
    ssr: false,
  },
);

const Index = (props: any) => {
  const router = useRouter();
  const [isUsed, setUsed] = useState<boolean>(false);

  useEffect(() => {
    const { token, auth, mature } = UserSession.getUserInfo();
    if (mature === 0) {
      router.replace('/');
    }
    const hash = router.asPath.match(/#([a-z0-9_=]+)/gi);
    if (hash && props.list) {
      const idx = _.findIndex(props.list, {
        artworksId: Number(hash[0].substring(1)),
      });

      if (idx >= 0) {
        const item = props.list[idx];

        if (item.matureBit === 2 && auth === 0) {
          if (!token) {
            router.push(
              `/?action=login&targetUrl=${window.location.pathname}${window.location.hash}`,
            );
            return;
          }
          router.push(
            `/?action=mature&targetUrl=${window.location.pathname}${window.location.hash}`,
          );
          return;
        }
      }
    }

    setUsed(true);
  }, []);

  return (
    <>
      <SeoComponent.Artworks />
      {isUsed && <ArtworksComponent {...props} />}
    </>
  );
};
 const _getServerSideProps = async (context: any) => {
  try {
    const URL = matureArtworksPath;
    const res = await fetch(URL);
    const listSSR = await res.json();
    if (listSSR) {
      return {
        props: {
          list: listSSR,
        },
      };
    }
    return {
      props: {
        list: [],
      },
    };
  } catch (err) {
    console.error(err);
  }
};

export default Index;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/artworks/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  